// language=GraphQL
export const ALL_FIELDS_QUERY = `query Query($withOptions: Boolean = false, $withVisibilityConfig: Boolean = false, $withVisibilityConfigPricingTravels: Boolean = false, $withVisibilityConfigPricingTravelsRatioCatalogBundle: Boolean = false, $withVisibilityConfigPricingTravelsDates: Boolean = false, $withVisibilityConfigPricingTravelsAccommodations: Boolean = false, $withVisibilityConfigPricingTravelsExtensionAccommodations: Boolean = false, $withVisibilityConfigPricingTravelsFamilyPackages: Boolean = false, $withVisibilityConfigPricingTravelsPersonalAddons: Boolean = false, $withVisibilityConfigPricingTravelsAccommodationAddons: Boolean = false, $withVisibilityConfigPricingTravelsBookingAddons: Boolean = false, $withVisibilityConfigPricingTravelsCollectiveAddons: Boolean = false, $withVisibilityConfigPricingTravelsExtensions: Boolean = false, $withVisibilityConfigPricingTravelsPersonalDiscounts: Boolean = false, $withVisibilityConfigPricingTravelsBookingDiscounts: Boolean = false, $withVisibilityConfigPricingTravelsCollectiveDiscounts: Boolean = false) {
  fields: customBookingFormFields {
    id
    inputType
    name
    label
    info
    value
    required
    options @include(if: $withOptions) {
      id
      value
      label
    }
    visibilityConfig @include(if: $withVisibilityConfig) {
      id
      pricingTravels @include(if: $withVisibilityConfigPricingTravels) {
        id
        ratioCatalogBundle @include(if: $withVisibilityConfigPricingTravelsRatioCatalogBundle) {
          id
          catalogCode
          travelCode
          json
        }
        catalogCode
        travelCode
        destination
        name
        transportType
        transportTypeLabel
        dates @include(if: $withVisibilityConfigPricingTravelsDates) {
          id
          dateNo
          startDate
          endDate
          isHidden
          includesExtension
          json
        }
        accommodations @include(if: $withVisibilityConfigPricingTravelsAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        extensionAccommodations @include(if: $withVisibilityConfigPricingTravelsExtensionAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          extensionAccommodationServiceNo
        }
        familyPackages @include(if: $withVisibilityConfigPricingTravelsFamilyPackages) {
          id
          ratioServiceNo
          name
          label
          info
        }
        personalAddons @include(if: $withVisibilityConfigPricingTravelsPersonalAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
        accommodationAddons @include(if: $withVisibilityConfigPricingTravelsAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
        bookingAddons @include(if: $withVisibilityConfigPricingTravelsBookingAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
        collectiveAddons @include(if: $withVisibilityConfigPricingTravelsCollectiveAddons) {
          id
          label
          info
        }
        extensions @include(if: $withVisibilityConfigPricingTravelsExtensions) {
          id
          label
          info
        }
        personalDiscounts @include(if: $withVisibilityConfigPricingTravelsPersonalDiscounts) {
          id
          ratioServiceNo
          name
          label
          info
        }
        bookingDiscounts @include(if: $withVisibilityConfigPricingTravelsBookingDiscounts) {
          id
          ratioServiceNo
          name
          label
          info
        }
        collectiveDiscounts @include(if: $withVisibilityConfigPricingTravelsCollectiveDiscounts) {
          id
          label
          info
        }
        importDateTime
        importStatus
        suppressBusBoardingSelection
      }
    }
    heading
  }
}`

// language=GraphQL
export const SINGLE_FIELD_QUERY = `query Query($id: ID!, $withOptions: Boolean = false, $withVisibilityConfig: Boolean = false, $withVisibilityConfigPricingTravels: Boolean = false, $withVisibilityConfigPricingTravelsRatioCatalogBundle: Boolean = false, $withVisibilityConfigPricingTravelsDates: Boolean = false, $withVisibilityConfigPricingTravelsAccommodations: Boolean = false, $withVisibilityConfigPricingTravelsExtensionAccommodations: Boolean = false, $withVisibilityConfigPricingTravelsFamilyPackages: Boolean = false, $withVisibilityConfigPricingTravelsPersonalAddons: Boolean = false, $withVisibilityConfigPricingTravelsAccommodationAddons: Boolean = false, $withVisibilityConfigPricingTravelsBookingAddons: Boolean = false, $withVisibilityConfigPricingTravelsCollectiveAddons: Boolean = false, $withVisibilityConfigPricingTravelsExtensions: Boolean = false, $withVisibilityConfigPricingTravelsPersonalDiscounts: Boolean = false, $withVisibilityConfigPricingTravelsBookingDiscounts: Boolean = false, $withVisibilityConfigPricingTravelsCollectiveDiscounts: Boolean = false) {
  field: customBookingFormField(id: $id) {
    id
    inputType
    name
    label
    info
    value
    required
    options @include(if: $withOptions) {
      id
      value
      label
    }
    visibilityConfig @include(if: $withVisibilityConfig) {
      id
      pricingTravels @include(if: $withVisibilityConfigPricingTravels) {
        id
        ratioCatalogBundle @include(if: $withVisibilityConfigPricingTravelsRatioCatalogBundle) {
          id
          catalogCode
          travelCode
          json
        }
        catalogCode
        travelCode
        destination
        name
        transportType
        transportTypeLabel
        dates @include(if: $withVisibilityConfigPricingTravelsDates) {
          id
          dateNo
          startDate
          endDate
          isHidden
          includesExtension
          json
        }
        accommodations @include(if: $withVisibilityConfigPricingTravelsAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        extensionAccommodations @include(if: $withVisibilityConfigPricingTravelsExtensionAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          extensionAccommodationServiceNo
        }
        familyPackages @include(if: $withVisibilityConfigPricingTravelsFamilyPackages) {
          id
          ratioServiceNo
          name
          label
          info
        }
        personalAddons @include(if: $withVisibilityConfigPricingTravelsPersonalAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
        accommodationAddons @include(if: $withVisibilityConfigPricingTravelsAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
        bookingAddons @include(if: $withVisibilityConfigPricingTravelsBookingAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
        collectiveAddons @include(if: $withVisibilityConfigPricingTravelsCollectiveAddons) {
          id
          label
          info
        }
        extensions @include(if: $withVisibilityConfigPricingTravelsExtensions) {
          id
          label
          info
        }
        personalDiscounts @include(if: $withVisibilityConfigPricingTravelsPersonalDiscounts) {
          id
          ratioServiceNo
          name
          label
          info
        }
        bookingDiscounts @include(if: $withVisibilityConfigPricingTravelsBookingDiscounts) {
          id
          ratioServiceNo
          name
          label
          info
        }
        collectiveDiscounts @include(if: $withVisibilityConfigPricingTravelsCollectiveDiscounts) {
          id
          label
          info
        }
        importDateTime
        importStatus
        suppressBusBoardingSelection
      }
    }
    heading
  }
}`

// language=GraphQL
export const CREATE_FIELD_MUTATION = `
  mutation Mutation($input: CreateCustomBookingFormFieldInput, $withOptions: Boolean = false, $withVisibilityConfig: Boolean = false, $withVisibilityConfigPricingTravels: Boolean = false, $withVisibilityConfigPricingTravelsRatioCatalogBundle: Boolean = false, $withVisibilityConfigPricingTravelsDates: Boolean = false, $withVisibilityConfigPricingTravelsAccommodations: Boolean = false, $withVisibilityConfigPricingTravelsExtensionAccommodations: Boolean = false, $withVisibilityConfigPricingTravelsFamilyPackages: Boolean = false, $withVisibilityConfigPricingTravelsPersonalAddons: Boolean = false, $withVisibilityConfigPricingTravelsAccommodationAddons: Boolean = false, $withVisibilityConfigPricingTravelsBookingAddons: Boolean = false, $withVisibilityConfigPricingTravelsCollectiveAddons: Boolean = false, $withVisibilityConfigPricingTravelsExtensions: Boolean = false, $withVisibilityConfigPricingTravelsPersonalDiscounts: Boolean = false, $withVisibilityConfigPricingTravelsBookingDiscounts: Boolean = false, $withVisibilityConfigPricingTravelsCollectiveDiscounts: Boolean = false) {
    field: createCustomBookingFormField(input: $input) {
      id
      inputType
      name
      label
      info
      value
      required
      options @include(if: $withOptions) {
        id
        value
        label
      }
      visibilityConfig @include(if: $withVisibilityConfig) {
        id
        pricingTravels @include(if: $withVisibilityConfigPricingTravels) {
          id
          ratioCatalogBundle @include(if: $withVisibilityConfigPricingTravelsRatioCatalogBundle) {
            id
            catalogCode
            travelCode
            json
          }
          catalogCode
          travelCode
          destination
          name
          transportType
          transportTypeLabel
          dates @include(if: $withVisibilityConfigPricingTravelsDates) {
            id
            dateNo
            startDate
            endDate
            isHidden
            includesExtension
            json
          }
          accommodations @include(if: $withVisibilityConfigPricingTravelsAccommodations) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          extensionAccommodations @include(if: $withVisibilityConfigPricingTravelsExtensionAccommodations) {
            id
            ratioPackageNo
            name
            label
            info
            extensionAccommodationServiceNo
          }
          familyPackages @include(if: $withVisibilityConfigPricingTravelsFamilyPackages) {
            id
            ratioServiceNo
            name
            label
            info
          }
          personalAddons @include(if: $withVisibilityConfigPricingTravelsPersonalAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
          accommodationAddons @include(if: $withVisibilityConfigPricingTravelsAccommodationAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
          bookingAddons @include(if: $withVisibilityConfigPricingTravelsBookingAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
          collectiveAddons @include(if: $withVisibilityConfigPricingTravelsCollectiveAddons) {
            id
            label
            info
          }
          extensions @include(if: $withVisibilityConfigPricingTravelsExtensions) {
            id
            label
            info
          }
          personalDiscounts @include(if: $withVisibilityConfigPricingTravelsPersonalDiscounts) {
            id
            ratioServiceNo
            name
            label
            info
          }
          bookingDiscounts @include(if: $withVisibilityConfigPricingTravelsBookingDiscounts) {
            id
            ratioServiceNo
            name
            label
            info
          }
          collectiveDiscounts @include(if: $withVisibilityConfigPricingTravelsCollectiveDiscounts) {
            id
            label
            info
          }
          importDateTime
          importStatus
          suppressBusBoardingSelection
        }
      }
      heading
    }
  }`

// language=GraphQL
export const UPDATE_FIELD_MUTATION = `
  mutation Mutation($input: UpdateCustomBookingFormFieldInput, $withOptions: Boolean = false, $withVisibilityConfig: Boolean = false, $withVisibilityConfigPricingTravels: Boolean = false, $withVisibilityConfigPricingTravelsRatioCatalogBundle: Boolean = false, $withVisibilityConfigPricingTravelsDates: Boolean = false, $withVisibilityConfigPricingTravelsAccommodations: Boolean = false, $withVisibilityConfigPricingTravelsExtensionAccommodations: Boolean = false, $withVisibilityConfigPricingTravelsFamilyPackages: Boolean = false, $withVisibilityConfigPricingTravelsPersonalAddons: Boolean = false, $withVisibilityConfigPricingTravelsAccommodationAddons: Boolean = false, $withVisibilityConfigPricingTravelsBookingAddons: Boolean = false, $withVisibilityConfigPricingTravelsCollectiveAddons: Boolean = false, $withVisibilityConfigPricingTravelsExtensions: Boolean = false, $withVisibilityConfigPricingTravelsPersonalDiscounts: Boolean = false, $withVisibilityConfigPricingTravelsBookingDiscounts: Boolean = false, $withVisibilityConfigPricingTravelsCollectiveDiscounts: Boolean = false) {
    field: updateCustomBookingFormField(input: $input) {
      id
      inputType
      name
      label
      info
      value
      required
      options @include(if: $withOptions) {
        id
        value
        label
      }
      visibilityConfig @include(if: $withVisibilityConfig) {
        id
        pricingTravels @include(if: $withVisibilityConfigPricingTravels) {
          id
          ratioCatalogBundle @include(if: $withVisibilityConfigPricingTravelsRatioCatalogBundle) {
            id
            catalogCode
            travelCode
            json
          }
          catalogCode
          travelCode
          destination
          name
          transportType
          transportTypeLabel
          dates @include(if: $withVisibilityConfigPricingTravelsDates) {
            id
            dateNo
            startDate
            endDate
            isHidden
            includesExtension
            json
          }
          accommodations @include(if: $withVisibilityConfigPricingTravelsAccommodations) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          extensionAccommodations @include(if: $withVisibilityConfigPricingTravelsExtensionAccommodations) {
            id
            ratioPackageNo
            name
            label
            info
            extensionAccommodationServiceNo
          }
          familyPackages @include(if: $withVisibilityConfigPricingTravelsFamilyPackages) {
            id
            ratioServiceNo
            name
            label
            info
          }
          personalAddons @include(if: $withVisibilityConfigPricingTravelsPersonalAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
          accommodationAddons @include(if: $withVisibilityConfigPricingTravelsAccommodationAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
          bookingAddons @include(if: $withVisibilityConfigPricingTravelsBookingAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
          collectiveAddons @include(if: $withVisibilityConfigPricingTravelsCollectiveAddons) {
            id
            label
            info
          }
          extensions @include(if: $withVisibilityConfigPricingTravelsExtensions) {
            id
            label
            info
          }
          personalDiscounts @include(if: $withVisibilityConfigPricingTravelsPersonalDiscounts) {
            id
            ratioServiceNo
            name
            label
            info
          }
          bookingDiscounts @include(if: $withVisibilityConfigPricingTravelsBookingDiscounts) {
            id
            ratioServiceNo
            name
            label
            info
          }
          collectiveDiscounts @include(if: $withVisibilityConfigPricingTravelsCollectiveDiscounts) {
            id
            label
            info
          }
          importDateTime
          importStatus
          suppressBusBoardingSelection
        }
      }
      heading
    }
  }`

// language=GraphQL
export const DELETE_FIELD_MUTATION = `
  mutation Mutation($input: DeleteCustomBookingFormFieldInput) {
    deleteCustomBookingFormField(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_FIELD_MUTATION = `
  mutation Mutation($input: DeleteCustomBookingFormFieldInput) {
    forceDeleteCustomBookingFormField(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_FIELD_OPTIONS_MUTATION = `
  mutation Mutation($input: addCustomBookingFormFieldOptionsInput) {
    addCustomBookingFormFieldOptions(input: $input) {
      id
      optionIds
    }
  }`

// language=GraphQL
export const REMOVE_FIELD_OPTIONS_MUTATION = `
  mutation Mutation($input: removeCustomBookingFormFieldOptionsInput) {
    removeCustomBookingFormFieldOptions(input: $input) {
      id
      optionIds
    }
  }`

// language=GraphQL
export const CREATE_FIELD_OPTIONS_MUTATION = `
  mutation Mutation($input: createCustomBookingFormFieldOptionsInput) {
    createCustomBookingFormFieldOptions(input: $input) {
      id
      optionIds
    }
  }`

// language=GraphQL
export const DELETE_FIELD_OPTIONS_MUTATION = `
  mutation Mutation($input: deleteCustomBookingFormFieldOptionsInput) {
    deleteCustomBookingFormFieldOptions(input: $input) {
      id
      optionIds
    }
  }`

// language=GraphQL
export const UPDATE_FIELD_OPTIONS_ORDER_MUTATION = `
  mutation Mutation($input: updateCustomBookingFormFieldOptionsOrderInput) {
    updateCustomBookingFormFieldOptionsOrder(input: $input) {
      id
      optionIds
    }
  }`

// language=GraphQL
export const FIELDS_DEPENDENTS_QUERY = `query Query($id: ID!, $withCustomBookingForm: Boolean = false) {
  groupedDependents: customBookingFormFieldDependents(id: $id) {
    customBookingForm @include(if: $withCustomBookingForm) {
      id
    }
  }
}`
